module.exports = __webpack_public_path__ + "images/STOP_LIGHT_ON.988c79ba1ad6bc38f460617c897b500d.png";